<template>
  <el-container class="home">
    <el-row class="m-b-100" justify="center">
      <el-col :span="18" class="m-t-20">
        <el-input v-model="phone" size="mini" placeholder="Хайх дугаараа оруулна уу" type="number"></el-input>
      </el-col>
      <el-col :span="4" class="m-t-20">
        <el-button class="w-100" size="mini" style="border-radius: 10px;" @click="getDeliveryByDriver" type="success">Хайх</el-button>
      </el-col>
      <el-col :span="2" class="m-t-20" style="display: flex; align-items: center; justify-content: center;">
        <el-button size="mini" style="border-radius: 10px;" @click="clearValue" type="primary">x</el-button>
      </el-col>
      <el-col :span="24" class="home_body m-t-20">
        <div>
          <el-card shadow="hover" class="m-t-10 cursor" style="border-radius:20px; line-height:2" v-for="(orderItem, index) in deliveryList" :key="index" @click.native="goToOrderDetail(orderItem)">
            {{ index + 1 }} - <span><a :href="'tel:' + orderItem.phone" class="blue_color_text">{{ orderItem.phone }}</a></span>
            <hr />
            <span class="flr" v-if="orderItem && orderItem.hvrgvvleh_ognoo">{{ orderItem.hvrgvvleh_ognoo.split('T')[0] }}</span><br />
            <span>{{ orderItem.DeliveryDetail.length }} ачаа</span>
            <span>
              <el-tag type="warning" class="flr" v-if="orderItem.status === 130">{{ returnStatusValue(orderItem.status) }}</el-tag>
              <el-tag type="danger" class="flr" v-if="orderItem.status === 180">{{ returnStatusValue(orderItem.status) }}</el-tag>
              <el-tag type="success" class="flr" v-if="orderItem.status === 200">{{ returnStatusValue(orderItem.status) }}</el-tag>
            </span><br />
            <span v-if="orderItem.Address">{{ orderItem.Address.detail_address }}<br /></span>
          </el-card>
          <el-pagination
            @current-change="handlePageChange"
            :current-page="currentPage"
            :page-size="pageSize"
            :total="totalRecords"
            layout="total, prev, pager, next, jumper"
            style="margin-top: 20px; text-align: right;" />
        </div>
        <OrderDetailDialog :deliveryDetails="deliveryDetail" @reloadDelivery="getDeliveryByDriver"></OrderDetailDialog>
      </el-col>
    </el-row>
  </el-container>
</template>

<script>
import services from '@/helpers/services.js'
import OrderDetailDialog from '@/views/orderDetail/orderDetail.vue'
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      user: 'userGetter'
    })
  },
  props: {
    progressCode: {
      type: Number,
      default: null
    }
  },
  components: {
    OrderDetailDialog
  },
  data () {
    return {
      token: JSON.parse(localStorage.getItem('idToken')),
      deliveryList: [],
      deliveryDetail: {},
      currentPage: 1,
      pageSize: 100,
      totalRecords: null,
      phone: null
    }
  },
  created () {
    this.getDeliveryByDriver()
  },
  watch: {
    progressCode () {
      this.getDeliveryByDriver()
    }
  },
  methods: {
    handlePageChange (page) {
      this.currentPage = page
      this.getDeliveryByDriver()
    },
    async getDeliveryByDriver () {
      try {
        const payload = { progress_code: this.progressCode, page: this.currentPage, limit: this.pageSize, phone: this.phone }
        const response = await services.getDeliveryByDriver(payload)
        if (response) {
          this.deliveryList = response.data
          this.totalRecords = response.total
          this.totalPages = response.totalPages
          this.$root.$emit('reloadCounFUnction')
        } else {
          this.$notify({
            title: 'Алдаа',
            message: 'Өгөгдөл хоосон байна',
            type: 'error',
            duration: 3000
          })
        }
      } catch (error) {
        console.error('Error fetching data: ', error)
        this.$notify({
          title: 'Алдаа',
          message: 'Уучлаарай: ' + error,
          type: 'error',
          duration: 3000
        })
      }
    },
    returnStatusValue (data) {
      const result = this.$root.statusArray.find(element => element.value === data)
      return result ? result.label : 'empty'
    },
    goToOrderDetail (data) {
      this.deliveryDetail = data
      this.$root.deliveryDetailDialog = true
    },
    clearValue () {
      this.phone = null
      this.getDeliveryByDriver()
    }
  }
}
</script>

<style>
.el-header {
  background-color: white;
  color: #5EC7CA;
  font-weight: bolder;
  font-size: 20px;
  line-height: 60px;
  padding: 0px;
  padding-right: 40px;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
  position: relative;
  width: 100%;
  left: 0;
  top: 0;
}
</style>
